
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import PinchZoom from 'pinch-zoom-js';
import * as OM from '@/model';
import { PhotoPrintRequestClient } from '@/services/Services'

@Options({})
export default class fullGalleryImageModal extends Vue {

    @Prop() item: OM.VillageGlobalGalleryItem;

    pz: PinchZoom = null;

    loaded: boolean = false;
    requested: OM.PhotoPrintRequest = null;
    showText: boolean = true;

    created(){
        this.init();
    }

    init(){
        this.loaded = false;
        PhotoPrintRequestClient.getPhotoPrintRequestExisting(this.item.identifier)
        .then(x => {
            this.loaded = true;
            this.requested = x;
        })
    }

    mounted(){
        let imgElement = this.$refs.pinch as HTMLImageElement;
        let pinchTextContainer = this.$refs.pinchTextContainer as HTMLDivElement;
        let textContainer = this.$refs.textContainer as HTMLDivElement;
        let timeout = null;
        let isHidden = false;
        imgElement.onload = (ev) => {
            this.pz = new PinchZoom(imgElement, {
                draggableUnzoomed: false,
                onZoomUpdate: onPinchUpdate,
                onDragUpdate: onPinchUpdate,
                onDoubleTap: onPinchUpdate,
            });
            setTimeout(() => {
                pinchTextContainer.style.top = imgElement.getBoundingClientRect().top + "px";
                pinchTextContainer.style.bottom = imgElement.getBoundingClientRect().bottom + "px";
                pinchTextContainer.style.height = imgElement.getBoundingClientRect().height + "px";
            })
        }
        function onPinchUpdate(target: any, event){
            if(!isHidden){
                isHidden = true;
                textContainer.style.opacity = "0";
                setTimeout(() => {
                    textContainer.style.display = "none";
                }, 200)
            }
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                if(target.zoomFactor == 1){
                    isHidden = false;
                    textContainer.style.display = "block";
                    setTimeout(() => {
                        textContainer.style.opacity = "1";
                    }, 100)
                }
            }, 600)
        }
    }
    
    beforeUnmount(): void {
        this.pz.destroy(); // Unmounts the zooming container and global event listeners
    }

    makePhotoPrintRequest(){
        this.loaded = false;
        PhotoPrintRequestClient.createPhotoPrintRequest(this.item.identifier)
        .then(x => {
            this.init();
        })
        .catch(err => {

        })
        .finally(() => {
            this.loaded = true;
        })
    }

    deleteRequest(){
        PhotoPrintRequestClient.cancelPhotoPrintRequest(this.item.identifier)
        .then(x => {
            this.init();
        })
    }
    
}

